<template>
  <div class="px-2 px-md-5 pt-3 pb-5">
    <h3 class="mb-5 text-white text-center text-sm-left">
      {{ $t("heading") }}
    </h3>
    <div class="alert alert-danger" v-if="errors">
      <ul class="list-unstyled mb-0">
        <li v-for="error in errors">{{ error[0] }}</li>
      </ul>
    </div>
    <form @submit.prevent="subscribe" v-if="!submitted">
      <div class="row">
        <div role="group" class="input-group col-md-12">
          <input
            id="email"
            type="email"
            v-model="email"
            :placeholder="$_t('KW:email')"
            class="form-control"
          />
          <div class="input-group-append">
            <button class="btn px-md-5" type="submit">
              <i class="fa fa-envelope mr-2"></i>
              {{ $t("signUp") }}
            </button>
          </div>
        </div>
      </div>
    </form>
    <strong v-else class="d-block text-center">{{ $t("thanks") }}</strong>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      errors: false,
      email: "",
      submitted: false,
    };
  },
  i18nOptions: {
    namespaces: "components",
    keyPrefix: "newsletter",
  },
  methods: {
    subscribe: function () {
      this.errors = false;
      this.$http
        .post("/api/subscribe", { email: this.email })
        .then((response) => {
          return (this.submitted = true);
        })
        .catch((error) => (this.errors = error.response.data.error));
    },
  },
};
</script>

<style lang="scss" scoped>
.input-group {
  input {
    height: 60px;
    font-size: 1rem;
    border-radius: 100px 0 0 100px;
    border: none;
    padding-left: 30px;
    color: $white;
    background-color: rgba(0, 0, 0, 0.3);
    &::placeholder {
      color: $white;
    }
    &:focus,
    &:active {
      border: none;
      outline: none;
    }
  }
  .input-group-append button {
    border-radius: 0 100px 100px 0;
    font-size: 1rem;
    color: $dark-blue;
    border-color: $secondary;
    background: $secondary;
  }
}
</style>